<template>
      <div id="sign-content" class="p max-width-2 mb2 mx-auto p1 " style="transform: scale(0.9); line-height: 29px;max-height:80vh;overflow:scroll; overflow-x: auto; background-color:white;">

              <div class="flex justify-start flex-start align-middle" >
                <img class="cbx-logo " style="width: 140px; height:140px;" src="../assets/cql_logo.svg">
                <h2 class="h0 color-cta  regular  lh-2">{{$t('contract_contract_agreement')}}</h2>
              </div>

              <contract-text-de v-if="$i18n.locale == 'de'" />
              <contract-text-en v-if="$i18n.locale == 'en'" />
            
          </div>
   
</template>

<script>
import contract_text_de from './contract_text_de.vue' 
import contract_text_en from './contract_text_en.vue' 

export default {
  name: 'contract',
  components: {
    'contract-text-de': contract_text_de,
    'contract-text-en': contract_text_en
  },
}
</script>

<style scoped>

</style>